import { apiPost } from '@/lib/http/client';
import { logger } from '@/lib/logger';

/** Interaction name for CRM record-save timing. */
export const CRM_SAVE_TIMING = 'crm_save';
/** Interaction name for proposal approve/reject timing. */
export const PROPOSAL_DECISION_TIMING = 'proposal_decision';

/**
 * Closed set of instrumented interactions — mirrored by the backend beacon
 * allowlist (VALID_INTERACTIONS in apps/utils/views.py). Update in lockstep.
 */
export type TimingInteraction =
  | typeof CRM_SAVE_TIMING
  | typeof PROPOSAL_DECISION_TIMING;

const INTERACTION_METRICS_ENDPOINT = '/api/metrics/frontend/interaction/';
const INTERACTION_BEACON_TIMEOUT_MS = 5_000;

/**
 * Emit an interaction-latency beacon. Computes `duration_ms` from
 * `startTimeMs` (a prior `performance.now()` value) to now and posts it with
 * `properties` to the frontend metrics endpoint, which records it as an OTel
 * histogram (`ahoy.frontend.interaction_ms`) queryable in Grafana.
 * Fire-and-forget — never awaited, so it never sits on the user-facing
 * critical path; delivery failures are logged and swallowed.
 */
export function trackTiming(
  interaction: TimingInteraction,
  startTimeMs: number,
  properties?: Record<string, unknown>
): void {
  const durationMs = Math.round(performance.now() - startTimeMs);
  apiPost(
    INTERACTION_METRICS_ENDPOINT,
    { ...properties, interaction, duration_ms: durationMs },
    INTERACTION_BEACON_TIMEOUT_MS
  ).catch((err: unknown) => {
    logger.warn('Interaction timing beacon failed', { error: String(err) });
  });
}
